import { alpha, Theme } from "@mui/material"


const getDisabledColor = (theme: Theme) => theme.palette.mode === 'light' ? alpha(theme.palette.text.disabled, 0.54) : theme.palette.text.disabled
export const disabledColor = {
  color: getDisabledColor,
  WebkitTextFillColor: getDisabledColor,
}
